import React, { Component } from "react"

class Input extends Component {
  render() {
    return (
      <input
        className="form-control"
        ref={(input) => (this.input = input)}
        {...this.props}
      />
    )
  }

  getValue() {
    if (this.input === null) {
      return ""
    }
    return this.input.value.trim()
  }
}

export default Input
